/**
 * @desc 产品BOM-作废
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductBomInvalidRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBom/invalid`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
